var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"vue-avatar","mode":"out-in"}},[_c('div',{key:_vm.loaded_src,staticClass:"vue-avatar",style:(_vm.style)},[(!_vm.image_exists)?_c('span',[_vm._v(_vm._s(_vm.initials))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }